import React from 'react'
import ProductHistoryPrice from '../../Products/ProductHistoryPrice/ProductHistoryPrice'

const ProductsHistory = () => {
  return <ProductHistoryPrice many />
}

export default ProductsHistory
